module.exports = __webpack_public_path__ + "25714bf883d4dc7e056d00370c055c57.fbx";